"use client";

import styles from "./styles.module.css";
import { scrollToTop } from "@lib/helpers";

export default function ArrowTop({ style }: { style?: string }) {
  return (
    <button className={`${styles.button} ${style || ""}`} onClick={scrollToTop}>
      <svg
        className={styles.button__arrow}
        width="12"
        height="7"
        viewBox="0 0 12 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.39819 5.42703L5.25665 1.13794C5.65391 0.69634 6.34627 0.696339 6.74353 1.13794L10.602 5.42703"
          stroke="#FFE1B1"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </button>
  );
}
